var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalRd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#EEF4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_13250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 31.5V29.8333C27.3332 28.9493 26.982 28.1014 26.3569 27.4763C25.7317 26.8512 24.8839 26.5 23.9998 26.5H18.9998C18.1158 26.5 17.2679 26.8512 16.6428 27.4763C16.0177 28.1014 15.6665 28.9493 15.6665 29.8333V31.5",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 23.1667C23.3408 23.1667 24.8332 21.6743 24.8332 19.8333C24.8332 17.9924 23.3408 16.5 21.4998 16.5C19.6589 16.5 18.1665 17.9924 18.1665 19.8333C18.1665 21.6743 19.6589 23.1667 21.4998 23.1667Z",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3335 31.5001V29.8334C32.3329 29.0948 32.0871 28.3774 31.6346 27.7937C31.1821 27.2099 30.5486 26.793 29.8335 26.6084",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3335 16.6084C28.0505 16.792 28.686 17.209 29.1399 17.7937C29.5937 18.3783 29.84 19.0974 29.84 19.8376C29.84 20.5777 29.5937 21.2968 29.1399 21.8815C28.686 22.4661 28.0505 22.8831 27.3335 23.0667",
    stroke: "#003D7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_13250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalRd);
export default __webpack_public_path__ + "static/media/animalR&D.e2e7a2cf1fffb9a40212f8ac5b4b3fe5.svg";
export { ForwardRef as ReactComponent };